export default __webpack_public_path__ + "static/media/image.291632a5.png";